import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PostPrimaryParams } from '../interfaces/account.interface';
import {
  GlobalIntermediate,
  KycContactInfo,
  KycStatus,
  KycVerifyCountry,
  PrimaryKycForm,
  UserBasicInfor,
} from '../interfaces/kyc.interface';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class KycApi extends BaseApi {
  TANYAN_APPID: string = 'rkLw99xYXDxyAWbc';
  TANYAN_SECRET: string = 'rkLw99xYXDxyAWbc7Fl81c1sA6htijpR';

  get iovationBlackbox(): string {
    let v = '';
    if (window.IGLOO && window.IGLOO.getBlackbox) {
      const o = window.IGLOO.getBlackbox();
      v = (o && o.blackbox) ?? '';
    }
    return encodeURIComponent(v);
  }

  /**
   * 查询用户KYC信息
   */
  getKycContactInfo(): Observable<ResponseData<KycContactInfo>> {
    const url = `${environment.apiUrl}/v1/member/kyc/kycinfo`;
    return this.get(url);
  }

  /**
   * 查询用户KYC限额  /v1/member/kyc/getkycsettings
   */
  getKycSettings(): Promise<any> {
    const url = `${environment.apiUrl}/v1/member/kyc/getkycsettings`;
    return firstValueFrom(this.get(url));
  }

  /**
   * 取得KYC相关设定 /v1/member/kyc/memberkyclimit
   */
  getMemberKycLimit(): Promise<any> {
    const url = `${environment.apiUrl}/v1/member/kyc/memberkyclimit`;
    return firstValueFrom(this.get(url));
  }

  /**
   * 获取api 请求用户kyc状态   /v1/member/kyc/kyc
   */

  getKycStatus(): Promise<ResponseData<KycStatus[]>> {
    const url = `${environment.apiUrl}/v1/member/kyc/kyc`;
    return firstValueFrom(this.get(url));
  }

  /**
   *  kyc基础认证
   *
   * @param params 初级kyc 参数
   * @returns
   */
  postPrimary(params: PostPrimaryParams): Observable<ResponseData<boolean>> {
    const url = `${environment.apiUrl}/v1/member/kyc/primary`;
    this.dataCollectionService.gtmPush('kyc_basic');
    return this.post(url, {
      ...params,
      iovationBlackbox: this.iovationBlackbox,
    });
  }

  /**
   * kyc中国区中级认证
   *
   * @param name 真实姓名
   * @param idCardNumber 身份证号
   * @param bankCard 银行卡号
   * @param phoneNumber 电话号码
   * @param bankName 银行名称
   * @returns
   */
  postIntermediate(name: string, idCardNumber: string, bankCard: string, phoneNumber: string) {
    const url = `${environment.apiUrl}/v1/member/kyc/intermediate`;
    return firstValueFrom(
      this.post(url, {
        fullName: name,
        idcard: idCardNumber,
        bankcard: String(bankCard).replace(/ /g, ''),
        mobile: phoneNumber,
        iovationBlackbox: this.iovationBlackbox,
      })
    );
  }

  /**
   * 中级验证状态更新接口
   *
   * @param intermediateVerificationStatus  中级验证状态
   * @param verification3rdRefKey 第三方验证关联ID
   * @returns
   */
  updateStatus(intermediateVerificationStatus: any, verification3rdRefKey: any) {
    const url = `${environment.apiUrl}/v1/member/kyc/updatestatus`;
    return firstValueFrom(
      this.post(url, {
        intermediateVerificationStatus,
        verification3rdRefKey,
      })
    );
  }

  /**
   * 发送验证码
   *
   * @param phoneNumber
   * @param phone
   */
  sendSms(phone: string) {
    const url = `${environment.apiUrl}/v1/member/kyc/sendsms`;
    return firstValueFrom(this.get(url, { phone }));
  }

  /**
   * 验证码校验
   *
   * @param phoneNumber
   * @param phone
   * @param smsCode
   * @returns
   */
  verifySms(phone: string, smsCode: string) {
    const url = `${environment.apiUrl}/v1/member/kyc/verifysms`;
    return firstValueFrom(
      this.post(url, {
        phone,
        smsCode,
      })
    );
  }

  // verifyBankCard(cardNumber: string) {
  //   const timestamp: number = Date.now();
  //   const sign: string = this.generateTANYANSign(timestamp);
  //   console.log('sign init', sign);

  //   const url = `https://api.shumaidata.com/v4/bank_info/query?appid=${this.TANYAN_APPID}&timestamp=${timestamp}&sign=${sign}&bankcard=${cardNumber}`;
  //   return this.get(url);
  // }

  // private generateTANYANSign(timestamp: number): string {
  //   const beforeSign: string = `${this.TANYAN_APPID}&${timestamp}&${this.TANYAN_SECRET}`;
  //   //@ts-ignore
  //   return md5(beforeSign).toString();
  // }

  /**
   * 查询jumio支持的验证类型
   *
   * @param countryCode
   * @returns ResponseData<KycVerifyCountry>
   */
  verifyCountry(countryCode: string): Observable<ResponseData<KycVerifyCountry>> {
    const url = `${environment.apiUrl}/v1/member/kyc/country`;
    return this.get<ResponseData<KycVerifyCountry>>(url, { countryCode });
  }

  // country: string,
  // name?: string,
  // frontImage: string | null,
  // backImage: string | null,
  // idType: string,
  // firstName?: string,
  // lastName?: string

  /**
   * KYC中级验证国外
   *
   * @param params
   * @returns
   */
  globalintermediate(params: GlobalIntermediate): Observable<ResponseData<boolean>> {
    const url = `${environment.apiUrl}/v1/member/kyc/globalintermediate`;
    return this.post(url, {
      ...params,
      iovationBlackbox: this.iovationBlackbox,
    });
  }

  // /**
  //  * KYC高级第三方验证
  //  *
  //  * @param fileName 国家代码
  //  * @returns
  //  */
  // createUpLoadUrl(fileName?: string) {
  //   const url = `${environment.apiUrl}/v1/resource/upload/createuploadurl`;
  //   const params: any = {
  //     type: 'Kyc',
  //     fileName: fileName,
  //   };
  //   return this.post(url, params);
  // }

  // /**
  //  * KYC高级第三方api
  //  *
  //  * @param url
  //  * @param body
  //  * @param imgType
  //  * @returns
  //  */
  // putUrl(url: string, body: any, imgType: string) {
  //   const opitons = {
  //     headers: new HttpHeaders({
  //       'Content-Type': `${imgType}`,
  //     }),
  //   };
  //   return this.put(url, body, opitons);
  // }

  /**
   * KYC高级验证
   *
   * @param countryCode 国家代码
   * @param idType      证件类型
   * @param postalCode  邮编
   * @param city        城市
   * @param address     地址
   * @param networkImgeUrl 带地址的证件照
   * @returns
   */
  postAdanced(
    countryCode: string,
    idType: string,
    postalCode: string,
    city: string,
    address: string,
    networkImgeUrl: string
  ) {
    const url = `${environment.apiUrl}/v1/member/kyc/advanced`;
    return firstValueFrom(
      this.post(url, {
        countryCode: countryCode,
        idType: idType,
        postalCode: postalCode,
        city: city,
        address: address,
        networkImgeUrl: networkImgeUrl,
        iovationBlackbox: this.iovationBlackbox,
      })
    );
  }

  /**
   * 活体人脸 验证
   *
   * @param param 语言参数
   * @param param.locale
   * @returns
   */
  // getLiveCheckConnect(param: { locale: string }): Observable<ResponseData<LiveCheckConnect>> {
  //   const url = `${environment.apiUrl}/v1/member/kyc/getlivecheckconnect`;
  //   return this.post(url, param);
  // }

  /**
   * 获取用户基本信息
   */
  getMemberBasicInfo(): Promise<ResponseData<UserBasicInfor | null>> {
    const url = `${environment.apiUrl}/v1/member/kyc/getmemberbasicinfo`;
    return firstValueFrom(this.get(url));
  }

  /**
   * 保存用户初级kyc信息
   
   * @param params
   * @returns
   */
  onSavePrimaryKycForm(params: PrimaryKycForm): Observable<boolean> {
    const url = `${environment.apiUrl}/v1/member/kyc/cacheprimaryinfo`;
    return this.post<ResponseData<boolean>>(url, params).pipe(map(v => v?.data));
  }

  /**
   * 或用户已提交过的初级KYC
   *
   * @returns
   */
  getSavePrimaryKycForm(): Observable<PrimaryKycForm> {
    const url = `${environment.apiUrl}/v1/member/kyc/getprimarycacheinfo`;
    return this.get<ResponseData<PrimaryKycForm>>(url).pipe(map(v => v?.data));
  }
}
